import { identity, pickBy } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getQueryParam, toQueryString } from './utils';

export function useUrlQueryParams<T extends string>(
  defaultValues: Record<T, string>
): {
  queryParams: Record<T, string>;
  setQueryParams: (paramValues: { [key: string]: string | number | null | undefined }) => void;
} {
  const { search } = useLocation();
  const history = useHistory();

  const setQueryParams = useCallback(
    (paramValues: { [key: string]: string | number | null | undefined }) => {
      const newParams = pickBy(paramValues, identity);
      const newSearch = toQueryString(newParams);
      history.replace({ search: newSearch });
    },
    [history]
  );

  const queryParams = useMemo(() => {
    const params: Record<T, string> = {} as Record<T, string>;
    (Object.keys(defaultValues) as Array<T>).forEach((key) => {
      const urlQueryValue = getQueryParam(search, key);
      params[key] = urlQueryValue ?? defaultValues[key];
    });
    return params;
  }, [defaultValues, search]);

  return { queryParams, setQueryParams };
}
